/**
 * @since 7.1.0
 */
export var CalendarType;
(function (CalendarType) {
    /**
     * @since 7.1.0
     */
    CalendarType[CalendarType["LOCAL"] = 0] = "LOCAL";
    /**
     * @since 7.1.0
     */
    CalendarType[CalendarType["CAL_DAV"] = 1] = "CAL_DAV";
    /**
     * @since 7.1.0
     */
    CalendarType[CalendarType["EXCHANGE"] = 2] = "EXCHANGE";
    /**
     * @since 7.1.0
     */
    CalendarType[CalendarType["SUBSCRIPTION"] = 3] = "SUBSCRIPTION";
    /**
     * @since 7.1.0
     */
    CalendarType[CalendarType["BIRTHDAY"] = 4] = "BIRTHDAY";
})(CalendarType || (CalendarType = {}));
//# sourceMappingURL=calendar-type.js.map